export const MARKETING_SITE_URL = 'https://swiftype.com'
export const CONTACT_SALES_URL = `${MARKETING_SITE_URL}/contact-sales`
